import BaseStore from '@/store/base-store'

const options = {
  actions: {
    clear ({ commit }) {
      commit('item', {})
    }
  }
}
export default new BaseStore('tasks', options)



// WEBPACK FOOTER //
// ./src/store/modules/tasks.store.js